<template>
  <section class="shop-section">
    <b-container>
      <b-row>
        <b-col sm="12">
          <div class="shop-link-container">
            <a class="shop-link" href="https://apps.apple.com/us/app/back-to-the-stars/id6473790737" target="_blank"> <img class="ufo-img" src="../../assets/img/app-store-apple-logo.jpg" alt="Apple store"></a>
            <a class="shop-link" href="https://play.google.com/store/apps/details?id=com.otrila.Backtostars" target="_blank" title="Click to visit the Microsoft website"> <img class="ufo-img" src="../../assets/img/google-play-store.jpg" alt="Google play store"></a>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";
  .shop-link-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 112px;
  @media screen and (min-width: 320px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 40px;
  }
  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 40px;
  }
  @media screen and (min-width: 1440px) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 112px;
  }
  @media screen and (min-width: 1920px) {
  }
    .shop-link{
      img{
        width: 100%;
        max-width: 268px;
        height: 80px;
        @media screen and (min-width: 320px) {
          max-width: 214px;
          height: 64px;
        }
        @media screen and (min-width: 768px) {
          max-width: 184px;
          height: 56px;
        }
        @media screen and (min-width: 1440px) {
          max-width: 268px;
          height: 80px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
  }
</style>
